export enum CrosstabAxis {
  Fire = 'fire',
  Carat = 'carat',
  Brilliance = 'brilliance',
  Scintillation = 'scintillation',
  OpticalSymmetry = 'opticalSymmetry',
  ShapePerformance = 'shapePerformance',
  GlobalPerformance = 'globalPerformance',
  ShapePerformanceV2 = 'shapePerformanceV2',
  GlobalPerformanceV2 = 'globalPerformanceV2',
  DeadZones = 'deadZones',
  MunsellHue = 'munsellHue',
  MunsellChroma = 'munsellChroma',
  MunsellValue = 'munsellValue',
  PavilionPc = 'pavilionPc',
  PavilionAngle = 'pavilionAngle',
  CrownPc = 'crownPc',
  CrownAngle = 'crownAngle',
  TotalHeightPc = 'totalHeightPc',
  TotalHeightMm = 'totalHeightMm',
  WidthMm = 'widthMm',
  LengthMm = 'lengthMm',
  CuletPc = 'culetPc',
  TablePc = 'tablePc',
  DiameterRatio = 'diameterRatio',
  SpreadCt = 'spreadCt',
  SpreadPc = 'spreadPc',
}

export interface NumericAxisSettings {
  step: number;
  isManualRange?: boolean;
  rangeStart?: Nullable<number>;
}
